import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ThumbsDownIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Thumbs down`} {...props}>
    <Path
      d="M10.25 9.25 7.9 13.6c-.2.38-.65.57-1.06.44a.86.86 0 0 1-.6-1.06l.55-2.23H3.74c-.9 0-1.57-.84-1.36-1.72l.9-3.75a1.75 1.75 0 0 1 1.7-1.35h5.27v5.32Zm1.5-5.32h2v5.32h-2V3.93Z"
      fill="currentColor"
    />
  </Icon>
);
